/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsTestimonials = {
    init: function ($section) {
      const $testimonialSlider = $section.find('[data-slider]');
      const $prevButton = $section.find('.testimonial__nav--prev');
      const $nextButton = $section.find('.testimonial__nav--next');

      $testimonialSlider.flickity({
        wrapAround: false,
        initialIndex: 0,
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        watchCSS: true
      });

      const flkty = $testimonialSlider.data('flickity');

      function updateNavButtons() {
        const selectedIndex = flkty.selectedIndex;
        const slideCount = flkty.slides.length;

        if (selectedIndex === 0) {
          $prevButton.attr('disabled', true);
        } else {
          $prevButton.removeAttr('disabled');
        }
        
        if (selectedIndex === slideCount - 1) {
          $nextButton.attr('disabled', true);
        } else {
          $nextButton.removeAttr('disabled');
        }
      }

      $testimonialSlider.on('ready.flickity', updateNavButtons);

      $testimonialSlider.on('select.flickity', updateNavButtons);
      
      $section.on('click', '.testimonial__nav--prev', function () {
        $testimonialSlider.flickity('previous');
      });

      $section.on('click', '.testimonial__nav--next', function () {
        $testimonialSlider.flickity('next');
      });

      if (flkty) {
        updateNavButtons();
      }
      
      $testimonialSlider.on('settle.flickity', function () {
        $testimonialSlider.flickity('resize');
      });
    },
    blockSelect: function ($section, blockId) {
      const $testimonialSlider = $section.find('[data-slider]');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $testimonialSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
      $('.testimonial__nav--prev').off();
      $('.testimonial__nav--next').off();
    }
  }

  /******/
})()
  ;